// tslint:disable:no-unsafe-any (autogenerated)
import { genericDispatcherAction } from './generic-store-reducer';
import { dispatch } from './redux-store';
import { ILegacyStoreCreator, ILegacyStore, LegacyStore } from './legacy-store';

// tslint:disable-next-line:interface-over-type-literal (autogenerated)
type THandlerDescriptor = {
    handler: Function;
    context?: Object;
};
/**
 * @deprecated
 */
export class Dispatcher {
    private handlersByEventName: {
        [eventName: string]: THandlerDescriptor[];
    } = {};

    public dispatch<T>(eventName: string, data?: T): void {
        dispatch(genericDispatcherAction(eventName, data));
        (this.handlersByEventName[eventName] || []).forEach(
            (descriptor: THandlerDescriptor) =>
                descriptor.context
                    ? descriptor.handler.call(descriptor.context, data)
                    : descriptor.handler(data)
        );
    }
    public register<T>(eventName: string, handler: (data: T) => void, context?: Object): void {
        this.handlersByEventName[eventName] = this.handlersByEventName[eventName] || [];
        this.handlersByEventName[eventName].push({
            handler,
            context
        });
    }
    public unregister<T>(eventName: string, handler: (data: T) => void): void {
        this.handlersByEventName[eventName] = (this.handlersByEventName[eventName] || []).filter(
            (descriptor: THandlerDescriptor) => descriptor.handler !== handler
        );
    }

    public registerLegacyStore(storeCreator: ILegacyStoreCreator): ILegacyStore {
        return new LegacyStore(storeCreator);
    }
}

const dispatcher = new Dispatcher();
/**
 * @deprecated
 */
// tslint:disable-next-line:no-default-export (autogenerated)
export default dispatcher;
